'use client';

import _defineProperty from "/codebuild/output/src176/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src176/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import '@mantine/hooks';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { Box } from '../../../core/Box/Box.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import '../../Transition/transitions.mjs';
import { Transition } from '../../Transition/Transition.mjs';
import { useSliderContext } from '../Slider.context.mjs';
var Thumb = forwardRef(function (_ref, ref) {
  var max = _ref.max,
    min = _ref.min,
    value = _ref.value,
    position = _ref.position,
    label = _ref.label,
    dragging = _ref.dragging,
    onMouseDown = _ref.onMouseDown,
    onKeyDownCapture = _ref.onKeyDownCapture,
    labelTransitionProps = _ref.labelTransitionProps,
    labelAlwaysOn = _ref.labelAlwaysOn,
    thumbLabel = _ref.thumbLabel,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    showLabelOnHover = _ref.showLabelOnHover,
    isHovered = _ref.isHovered,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    disabled = _ref.disabled;
  var _useSliderContext = useSliderContext(),
    getStyles = _useSliderContext.getStyles;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var isVisible = labelAlwaysOn || dragging || focused || showLabelOnHover && isHovered;
  return /* @__PURE__ */jsxs(Box, _objectSpread(_objectSpread({
    tabIndex: 0,
    role: "slider",
    "aria-label": thumbLabel,
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    ref: ref,
    __vars: {
      "--slider-thumb-offset": "".concat(position, "%")
    }
  }, getStyles("thumb", {
    focusable: true
  })), {}, {
    mod: {
      dragging: dragging,
      disabled: disabled
    },
    onFocus: function onFocus() {
      setFocused(true);
      typeof _onFocus === "function" && _onFocus();
    },
    onBlur: function onBlur() {
      setFocused(false);
      typeof _onBlur === "function" && _onBlur();
    },
    onTouchStart: onMouseDown,
    onMouseDown: onMouseDown,
    onKeyDownCapture: onKeyDownCapture,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    children: [children, /* @__PURE__ */jsx(Transition, _objectSpread(_objectSpread({
      mounted: label != null && !!isVisible,
      transition: "fade",
      duration: 0
    }, labelTransitionProps), {}, {
      children: function children(transitionStyles) {
        return /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({}, getStyles("label", {
          style: transitionStyles
        })), {}, {
          children: label
        }));
      }
    }))]
  }));
});
Thumb.displayName = "@mantine/core/SliderThumb";
export { Thumb };